export const SIDES = ['Long', 'Short'] as const
export type Side = (typeof SIDES)[number]

export const SIDE_OPTIONS = SIDES.map((s) => ({
  label: s,
  value: s,
}))

// --------------------------------

export const CONTRACT_SIDES = ['longLowerShortUpper', 'shortLowerLongUpper'] as const
export type ContractSide = (typeof CONTRACT_SIDES)[number]

export const CONTRACT_SIDE_LABELS: Record<ContractSide, string> = {
  longLowerShortUpper: 'Long Lower Bound / Short Upper',
  shortLowerLongUpper: 'Short Lower Bound / Long Upper',
}

export const CONTRACT_SIDE_OPTIONS = CONTRACT_SIDES.map((c) => ({
  label: CONTRACT_SIDE_LABELS[c],
  value: c,
}))
